import angular from 'angular';
import { Lang } from 'Roblox';

const searchDropdown = angular
  .module('searchDropdown', ['searchDropdownHtmlTemplate', 'thumbnails'])
  .config([
    'languageResourceProvider',
    languageResourceProvider => {
      if (Lang.SearchDropdownComponentResources) {
        languageResourceProvider.setLanguageKeysFromFile(Lang.SearchDropdownComponentResources);
      }
    }
  ]);

export default searchDropdown;
